module.exports = __webpack_public_path__ + "img/audio-form-img.6f5b4203.png";